var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargingBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Charging-Battery-Empty--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Charging Battery Empty Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Charging-Battery-Empty--Streamline-Ultimate.svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 10.5a2 2 0 0 0 -2 -2h-1v-1a2 2 0 0 0 -2 -2h-4.25a0.25 0.25 0 0 0 -0.25 0.25v1.5a0.25 0.25 0 0 0 0.25 0.25h3.75a0.5 0.5 0 0 1 0.5 0.5v1.5a1 1 0 0 0 1 1h2v3h-2a1 1 0 0 0 -1 1V16a0.5 0.5 0 0 1 -0.5 0.5h-4.32a0.25 0.25 0 0 0 -0.19 0.09l-1.2 1.5a0.26 0.26 0 0 0 0 0.27 0.26 0.26 0 0 0 0.22 0.14h6a2 2 0 0 0 2 -2v-1h1a2 2 0 0 0 2 -2Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.5A0.5 0.5 0 0 1 2 16V8a0.5 0.5 0 0 1 0.5 -0.5h5.32A0.28 0.28 0 0 0 8 7.41l1.2 -1.5a0.26 0.26 0 0 0 0 -0.27 0.24 0.24 0 0 0 -0.2 -0.14H2a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h5.25a0.25 0.25 0 0 0 0.25 -0.25v-1.5a0.25 0.25 0 0 0 -0.25 -0.25Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79 11.94a0.87 0.87 0 0 0 -0.67 -1.44h-1.87a0.25 0.25 0 0 1 -0.25 -0.25V5a0.5 0.5 0 0 0 -0.89 -0.31l-5.9 7.37a0.87 0.87 0 0 0 0.67 1.44h1.87a0.25 0.25 0 0 1 0.25 0.25V19a0.5 0.5 0 0 0 0.89 0.31Z",
    fill: "#000000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingBattery);
export default __webpack_public_path__ + "static/media/Charging-Battery.2c44f8447eb1ad98875f594307f4d406.svg";
export { ForwardRef as ReactComponent };